import { Blog } from "../components/Blog";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import SecondHero from "../components/SecondHero";
import w7 from "../assets/w7.jpg";
function BlogPage() {
  return (
    <div>
      <Navbar />
      <SecondHero title={"Blog"} breadcrumb="Blog" img={w7} />
      <Blog />
      <Footer />
    </div>
  );
}

export default BlogPage;
